import { gql } from '@apollo/client';
import { ActivitySessionFragments } from '../ActivitySidebar/ActivitySessionFragments.gql';

export const GET_SELF_DIRECTED_ACTIVITY = gql`
  query GetSelfDirectedActivity($activityId: String!) {
    vm {
      activity(activityId: $activityId) {
        activityId
        name
        description
        endDate
        activityType
        sessions(includeOneOff: true) {
          ...ActivitySession
        }
      }
    }
  }
  ${ActivitySessionFragments}
`;
